import goldenZone1 from './goldenZone1.png';

export const GoldenZone1 = (props: JSX.IntrinsicElements['img']) => (
  <img alt="golden zone 1" width={125} height={125} {...props} src={goldenZone1} />
);
